var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home_bj"},[_c('div',{staticClass:"home_time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"home_btn",on:{"click":_vm.goLive}},[_vm._v("进入直播")])])])}
var staticRenderFns = []

export { render, staticRenderFns }